
/**
 * Create a HUD Counter object.
 *
 * A HUD Counter object displays game properties such as time remaining, coins
 * collected etc.
 *
 * @param  {object} game  [description]
 * @param  {int} 	x     [description]
 * @param  {int} 	y     [description]
 * @param  {object} group [description]
 * @return {object}
 */
Game.Prefabs.HudCounter = function( game, group ) {

	Phaser.Sprite.call( this, game, 0, 0, 'hud' );

	this.counter = game.add.retroFont( 'font', 4, 6, Game.font_set, 8, 3, 1, 2, 1 );

	this.counter_image = game.add.image( 0, 0, this.counter );

	this.updatePosition();

	group.add( this );
	group.add( this.counter_image );

};

Game.Prefabs.HudCounter.prototype = Object.create( Phaser.Sprite.prototype );

Game.Prefabs.HudCounter.prototype.constructor = Game.Prefabs.HudCounter;


/**
 * Constant that lists frame ids for the different counter designs.
 *
 * @type {Object}
 */
Game.Prefabs.HudCounter.COUNTER_TYPE = {
	'default': 0,
	'distance': 1,
	'coin': 2,
	'time': 3,
};


/**
 * Update the text value of the counter text.
 *
 * @param  {string} value The new value to display in the counter widget.
 */
Game.Prefabs.HudCounter.prototype.setText = function( value ) {

	this.counter.text = value.toString();
	this.updatePosition();

};


/**
 * Get the current hud counters text value.
 *
 * @return {string}
 */
Game.Prefabs.HudCounter.prototype.getText = function() {

	return this.counter.text;

};


/**
 * Get the numerical value of the current hud counter.
 *
 * @return {float} [description]
 */
Game.Prefabs.HudCounter.prototype.getValue = function() {

	return parseFloat( this.counter.text );

};


/**
 * Update the position of the hud counter, and its text object.
 */
Game.Prefabs.HudCounter.prototype.updatePosition = function() {

	this.counter_image.x = this.x + 8;
	this.counter_image.y = this.y + 1;

};
